import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UTLabel, UTLoading } from '@widergy/energy-ui';

import UTModal from 'app/components/UTModal';
import { message } from 'utils/stringUtils';

import styles from './styles';

export default class DeleteAccount extends Component {
  handleDeleteAccount = () => {
    this.props.onDeleteAccount(this.props.deleteAccountId);
  };

  render() {
    const { deleteAccountLoading, deleteModalIsOpen, onDeleteModalClose } = this.props;
    return (
      <UTModal
        isOpen={deleteModalIsOpen}
        onRequestClose={onDeleteModalClose}
        cancelButton={
          !deleteAccountLoading ? { text: message('Commons:cancel'), onPress: onDeleteModalClose } : false
        }
        acceptButton={
          !deleteAccountLoading
            ? { text: message('Commons:accept'), onPress: this.handleDeleteAccount }
            : false
        }
        contentLabel={message('Accounts:deleteAccount')}
        title={message('Accounts:deleteAccount')}
        imageModal
      >
        <div style={styles.modalContent}>
          <UTLoading loading={deleteAccountLoading}>
            <UTLabel>{message('Accounts:deleteAccountConfirmation')}</UTLabel>
          </UTLoading>
        </div>
      </UTModal>
    );
  }
}

DeleteAccount.propTypes = {
  onDeleteAccount: PropTypes.func.isRequired,
  onDeleteModalClose: PropTypes.func.isRequired,
  deleteAccountId: PropTypes.number,
  deleteModalIsOpen: PropTypes.bool.isRequired,
  deleteAccountLoading: PropTypes.bool
};
